import { Col, Row, Typography } from "antd";
import { PRIVACY } from "../../../constants/AppConstants";

import "./General.css";
import { Fragment } from "react/jsx-runtime";

const { Title, Paragraph } = Typography;

export default function General() {
  return (
    <Row className="my-40">
      <Col xs={1} sm={1} md={2} lg={4}></Col>
      <Col xs={22} sm={22} md={20} lg={16}>
        <Title className="privacy-general-title" level={3}>
          {PRIVACY.GENERAL.TITLE}
        </Title>
        {PRIVACY.GENERAL.TEXT.map((linea, index) => (
          <Fragment key={index}>
            <Paragraph className="privacy-general-description">
              {linea}
            </Paragraph>
          </Fragment>
        ))}
      </Col>
      <Col xs={1} sm={1} md={2} lg={4}></Col>
    </Row>
  );
}
